export default __webpack_public_path__ + "static/media/exit.4fd66077.svg";